import {
  BasicLayoutProps,
  Settings as LayoutSettings,
} from '@ant-design/pro-layout';
import Footer from '@/components/Footer';
import RightContent from '@/components/RightContent';
import { SelectLang } from 'umi';

export const locale = {
  default: 'zh-CN',
};

export const layout = ({
  initialState,
}: {
  initialState: { settings?: LayoutSettings };
}): BasicLayoutProps => {
  return {
    footerRender: () => <Footer />,
    // headerRender: false,  //不显示顶栏
    rightContentRender: () => <RightContent />,
    menuHeaderRender: undefined,
    headerHeight: 80,
    // headerTitleRender: () => {
    //   return(
    //     // 这里插入一个校徽
    //     <>
    //       <Image
    //         height={'85%'}
    //         preview={false}
    //         style={{ float:'left', marginTop:10 }}
    //         src={require('/src/assets/white.png')}
    //       />
    //       <div style={{ color:'white', fontSize:18, marginLeft:80, marginTop:-117 }}>

    //         <div style={{marginBottom:-50, marginTop:-15 }}><big><b>源流</b></big>大数据分析平台</div> <p><big><b>Evol</b></big> Data Analysis Platform of Ancient Chinese Literature</p>
    //       </div>
    //       </>
    //   )
    // },
    headerRender: () => {
      return (
        <div
          className="header"
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
            color: 'white',
            padding: '12px 16px',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <div className="header-logo" style={{ height: '100%' }}>
            <img
              src={require('/src/assets/white.png')}
              style={{ height: '100%', verticalAlign: 'baseline' }}
            />
          </div>
          <div
            className="header-title"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              flex: 1,
              height: '100%',
              fontSize: 18,
              lineHeight: 1.4,
              padding: '0 16px',
            }}
          >
            <div>
              <big>
                <b><font face='楷体'>源流</font></b>
              </big>
              <font size ='3'>大数据分析平台</font>
            </div>
            <div>
              <big>
                <b><font face='Times New Roman'>Evol </font></b>
              </big>
              <font size = '3'>Data Analysis Platform of Ancient Chinese Literature</font>
            </div>
          </div>
          <div
            className="header-actions"
            style={{
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <SelectLang reload={false} />
          </div>
        </div>
      );
    },
    menu: { locale: true },
    ...initialState?.settings,
  };
};
